
    import './styles.scoped.css';
    export default {
  "link": "awsui_link_4c84z_187dx_34",
  "variant-recovery": "awsui_variant-recovery_4c84z_187dx_102",
  "variant-secondary": "awsui_variant-secondary_4c84z_187dx_135",
  "variant-primary": "awsui_variant-primary_4c84z_187dx_170",
  "variant-info": "awsui_variant-info_4c84z_187dx_203",
  "variant-value-large": "awsui_variant-value-large_4c84z_187dx_238",
  "variant-top-navigation": "awsui_variant-top-navigation_4c84z_187dx_270",
  "button": "awsui_button_4c84z_187dx_305",
  "color-inverted": "awsui_color-inverted_4c84z_187dx_379",
  "font-size-body-s": "awsui_font-size-body-s_4c84z_187dx_410",
  "font-size-body-m": "awsui_font-size-body-m_4c84z_187dx_418",
  "font-size-heading-xs": "awsui_font-size-heading-xs_4c84z_187dx_425",
  "font-size-heading-s": "awsui_font-size-heading-s_4c84z_187dx_433",
  "font-size-heading-m": "awsui_font-size-heading-m_4c84z_187dx_441",
  "font-size-heading-l": "awsui_font-size-heading-l_4c84z_187dx_449",
  "font-size-heading-xl": "awsui_font-size-heading-xl_4c84z_187dx_457",
  "font-size-display-l": "awsui_font-size-display-l_4c84z_187dx_465",
  "font-size-inherit": "awsui_font-size-inherit_4c84z_187dx_473",
  "in-inline-token": "awsui_in-inline-token_4c84z_187dx_481",
  "icon-wrapper": "awsui_icon-wrapper_4c84z_187dx_485",
  "icon": "awsui_icon_4c84z_187dx_485"
};
  